export const pluralize = (val?: any, plural = 's', singular = '') => {
  return typeof val !== 'number' || val === 1 ? singular : plural;
};
